module.exports = __webpack_public_path__ + "media/images/responsive/articles/icon_pager_gap-938f44bbe3bc1d34f29306a4bc10a3ef.svg";